import { useState, ReactNode } from 'react'
import clsx from 'clsx';
import { makeStyles, Menu, Typography, IconButton } from '@material-ui/core'
import { FontWeight, Color, Value } from 'theme/style'
import { useRouter } from 'app/utils'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import MoreVertIcon from '@material-ui/icons/MoreVert'

const useStyles = makeStyles((theme) => ({
  header: {
    width: '100%',
    backgroundColor: Color.Background,
    height: '70px',
    flex: '0 0 70px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 2),
    alignItems: 'center',
    borderTopLeftRadius: Value.BorderRadius,
    borderTopRightRadius: Value.BorderRadius,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginLeft: '40px',
    },
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    alignItems: 'center'
  },
  backArrowContainer: {
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(1),
    borderRadius: '20px',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: Color.Background,
    }
  },
  backArrow: {
    height: '24px',
    width: '24px',
    color: Color.TextPrimary,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  title: {
    fontWeight: FontWeight.SemiBold,
  },
  subtitle: {
    fontWeight: FontWeight.Regular,
    color: theme.palette.text.primary
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    '&>*': {
      marginLeft: theme.spacing(1)
    }
  },
  tabsContainer: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
    flex: 1,
    position: 'relative',
    top: '3px',

    // [theme.breakpoints.down('sm')]: {
    //   display: 'none'
    // },
  },
  tab: {
    ...theme.typography.body1,
    height: '22px',
    cursor: 'pointer',
    textAlign: 'center',
    color: Color.TextDisabled,
    marginRight: theme.spacing(2),
    fontWeight: FontWeight.SemiBold
  },
  selectedTab: {
    borderBottom: '2px solid transparent',
    borderBottomColor: Color.Primary,
    color: Color.TextSecondary
  },
  actionsContainer: {
    display: 'block',
    flex: '0 0 auto',
    // marginRight: theme.spacing(1)
    // [theme.breakpoints.down('sm')]: {
    //   display: 'none'
    // },
  },
  secondaryActionsContainer: {
    paddingLeft: theme.spacing(1),
    marginLeft: theme.spacing(2),
    // borderLeft: '2px solid transparent',
    // borderLeftColor: Color.Background
  },
  titleSection: {
    ...theme.typography.body1,
    cursor: 'pointer',
    marginLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    color: Color.TextSecondary,
    fontWeight: FontWeight.Medium,
    top: '2px'
  },
  separator: {
    backgroundColor: '#EBE8E8',
    width: 'calc(100% + 80px)',
    height: '2px',
    position: 'relative',
    left: '-20px'
  }
}))

type PageHeaderProps = {
  className?: string
  title: string

  actions?: ReactNode
  secondaryActions?: ReactNode[]
  supportActions?: ReactNode
  previousRoute?: string
}
const PageHeader = ({ ...props }: PageHeaderProps) => {
  const classes = useStyles()
  const router = useRouter()



  //ACTIONS

  const [anchorSecondaryActionsEl, setAnchorSecondaryActionsEl] = useState<null | HTMLElement>(null)
  const secondaryActionsAreOpen = Boolean(anchorSecondaryActionsEl)

  const openSecondaryActions = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorSecondaryActionsEl(event.currentTarget)
  }

  const closeSecondaryActions = () => {
    setAnchorSecondaryActionsEl(null)
  }



  //RENDER

  return (
    <div className={clsx(props.className, classes.header)} >
      <div className={classes.headerContent}>
        <div className={classes.leftContent}>
          {props.previousRoute != null &&
            <div className={classes.backArrowContainer} onClick={() => router.history.push(props.previousRoute ?? '')}>
              <ArrowBackIcon className={classes.backArrow} />
            </div>
          }
          <div className={classes.titleContainer}>
            <Typography className={classes.title} component="h1" variant="h3">
              {props.title}
            </Typography>
          </div>
        </div>

        <div className={classes.rightContent}>
          <div className={classes.actionsContainer}>
            {props.actions}
          </div>
          {(props.supportActions != null || props.secondaryActions != null) &&
            <div className={classes.secondaryActionsContainer}>
              {props.supportActions != null &&
                <>
                  {props.supportActions}
                </>
              }
              {props.secondaryActions != null &&
                <>
                  <IconButton onClick={openSecondaryActions}><MoreVertIcon /></IconButton>
                  <Menu anchorEl={anchorSecondaryActionsEl} open={secondaryActionsAreOpen} onClick={closeSecondaryActions} onClose={closeSecondaryActions}>
                    {props.secondaryActions?.map(e => e)}
                  </Menu>
                </>
              }
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default PageHeader
